import { render, staticRenderFns } from "./PromotionHeader.vue?vue&type=template&id=e6ed7b80"
import script from "./PromotionHeader.vue?vue&type=script&lang=js"
export * from "./PromotionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports